"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Text = _interopRequireDefault(require("../Text/Text"));

require("antd/dist/antd.css");

require("./RadioButtonComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var radio = function radio(_ref) {
  var options = _ref.options,
      disabled = _ref.disabled,
      value = _ref.value,
      onChange = _ref.onChange,
      optionType = _ref.optionType,
      buttonStyle = _ref.buttonStyle,
      name = _ref.name,
      id = _ref.id,
      className = _ref.className,
      labelStyle = _ref.labelStyle,
      boldLabel = _ref.boldLabel,
      defaultValue = _ref.defaultValue;
  return /*#__PURE__*/_react["default"].createElement(_antd.Radio.Group, {
    "data-test": "radio-component",
    disabled: disabled || false,
    value: value,
    onChange: onChange,
    optionType: optionType || "default",
    buttonStyle: buttonStyle || "outline",
    name: name,
    id: id,
    className: "".concat(className, " iiht-ant-radio"),
    defaultValue: defaultValue
  }, options && (options === null || options === void 0 ? void 0 : options.map(function (el, index) {
    return /*#__PURE__*/_react["default"].createElement(_antd.Radio, {
      key: el === null || el === void 0 ? void 0 : el.key,
      value: el === null || el === void 0 ? void 0 : el.value
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      strong: boldLabel,
      className: labelStyle
    }, el === null || el === void 0 ? void 0 : el.label), el !== null && el !== void 0 && el.underText ? /*#__PURE__*/_react["default"].createElement("p", null, el.underText) : null);
  })));
};

var _default = radio;
exports["default"] = _default;